/**
 * Parse API/DB timestamps for India (IST).
 * Naive "YYYY-MM-DD HH:mm:ss" values from PostgreSQL are IST wall time, not UTC.
 */
const IST_OFFSET_MS = (5 * 60 + 30) * 60 * 1000;

export const parseAppTimestamp = (dateValue) => {
  if (!dateValue) return null;
  if (dateValue instanceof Date) {
    return Number.isNaN(dateValue.getTime()) ? null : dateValue;
  }

  const raw = String(dateValue).trim();
  if (!raw) return null;

  if (/(?:Z|[+-]\d{2}:?\d{2})$/i.test(raw)) {
    const parsed = new Date(raw);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const naive = raw.match(
    /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?/,
  );
  if (naive) {
    const [, y, mo, d, h, mi, s = "0"] = naive;
    const utcMs =
      Date.UTC(Number(y), Number(mo) - 1, Number(d), Number(h), Number(mi), Number(s)) -
      IST_OFFSET_MS;
    return new Date(utcMs);
  }

  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatInIst = (dateValue, { withSeconds = false } = {}) => {
  const date = parseAppTimestamp(dateValue);
  if (!date) return "—";
  return `${date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    ...(withSeconds ? { second: "2-digit" } : {}),
    hour12: false,
  })} IST`;
};
